import { useEffect } from 'react';

import { useGetSelectedOrganisation } from '../../../hooks/useGetSelectedOrganisation';
import { useInvoice } from '../../../hooks/useInvoice';
import { useActionInvoiceMutation } from '../../../services/api/invoiceApi/invoice';

import { InvoiceActivityFeed } from './InvoiceActivityFeed';
import { InvoiceDetailsCard } from './InvoiceDetailsCard';
import { InvoicePaperV2 } from './InvoicePaperV2';

export const INVOICE_COLUMN_ID = `invoice-column`;

/** Invoice tab: the invoice on the left, details and activity on the right. Columns scroll on their own on wide screens */
export function InvoiceOverviewV2() {
  const { invoice } = useInvoice();
  const organisation = useGetSelectedOrganisation();
  const [actionInvoice] = useActionInvoiceMutation();

  useEffect(() => {
    actionInvoice({ organisationId: organisation.id, invoiceId: invoice.id, action: `resync` });
  }, []);

  return (
    <div className={ `grid grid-cols-1 gap-5 xl:h-full xl:grid-cols-[minmax(0,1fr)_35rem]` }>
      <div
        id={ INVOICE_COLUMN_ID }
        className={ `xl:min-h-0 xl:overflow-auto` }
      >
        <InvoicePaperV2 />
      </div>
      <div className={ `flex flex-col gap-3 xl:min-h-0` }>
        <InvoiceDetailsCard />
        <InvoiceActivityFeed />
      </div>
    </div>
  );
}
